// geekfan.mx — Hero Slideshow Fixes
// Disables auto-rotate and improves mobile UX
document.addEventListener('DOMContentLoaded', function() {
  // Disable all slideshow auto-rotate
  document.querySelectorAll('slideshow-component').forEach(function(el) {
    el.setAttribute('data-autoplay', 'false');
    el.pauseSlideshow && el.pauseSlideshow();
  });

  // Force mobile text below image (not overlaid)
  if (window.innerWidth < 750) {
    document.querySelectorAll('.banner--mobile-bottom').forEach(function(el) {
      el.classList.remove('banner--mobile-bottom');
    });
  }
});
